import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_VER === "production") {
  Sentry.init({
    dsn: "https://46fc8e1e675ce4fc836fae8a1ff817e3@o4508972337397760.ingest.de.sentry.io/4508972354240592",
    integrations: [Sentry.replayIntegration()],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
